import React from "react";
import { TextField } from "@td/ui";
import { translate } from "@td/shared_utils";
import { fieldTypes } from "../constants";

const NotesField = React.memo(() => (
  <TextField
    rows={7}
    name={fieldTypes.NOTES}
    label={translate(null, "care_team_tasks.form.fields.notes", "label")}
  />
));

export default NotesField;
